import { z } from 'zod';

export const rebuildClipsRequestSchema = z.object({
  collectionId: z.number().int().positive().optional(),
  cursor: z.string().optional(),
  limit: z.number().int().positive().optional(),
});

export type IRebuildClipsRequest = z.input<typeof rebuildClipsRequestSchema>;
